<div class="d-flex" style="height: 100%; justify-content: center">
  <section id="icon">
    <img class="img-plus" [src]="this.tabPosition === 0 ? 'assets/images/icons/ic_controller.svg' : 'assets/images/icons/ic_tickets.svg'" height="90vh" alt="Logo" />
  </section>
  <section id="comment">
    <p class="text-plus align-center" [ngStyle]="{ color: this.tabPosition === 0 ? 'white' : 'black' }">
      Aquí puedes ver el historial<br />
      de jugadas y etickets.
    </p>
  </section>
</div>
